import Marker from './Marker';

import styles from '../../assets/json/map-styles.json';

class Map {
  constructor() {
    this.dom = {};

    this.state = {
      zoom: null
    };

    this.map = null;

    this.locations = [];
    this.markers = [];
  }

  initLocations = () => {
    const locations = this.dom.mapEl.querySelectorAll('.js-location');

    [...locations].forEach((location) => {
      let data = {};
      data.title = location.getAttribute('data-title');
      data.category = location.getAttribute('data-category');
      data.address = location.getAttribute('data-address');
      data.lat = parseFloat(location.getAttribute('data-lat'));
      data.lng = parseFloat(location.getAttribute('data-lng'));
      data.color = location.getAttribute('data-color');
      data.url = location.getAttribute('data-url');

      this.locations.push(data);
    });

    // this.locations = this.locations.slice(1);
  }

  initMap = () => {
    this.map = new window.google.maps.Map(this.dom.mapEl, {
      styles,
      disableDefaultUI: true
    });
  }

  initMarkers = () => {
    let marker;
    let latlng;

    // create markers
    this.markers = this.locations.map((location) => {
      latlng = new window.google.maps.LatLng(location.lat, location.lng);

      marker = new Marker({
        latlng,
        map: this.map,
        markup: `
          <div class="map__marker">
            <button class="map__marker-button" style="background-color: ${location.color}">
              <div class="map__marker-icon"></div>
            </button>

            <div class="map__marker-tooltip">
              <span>${location.category}</span>
              ${location.title}
            </div>
          </div>
        `,
        url: location.url
      });

      return marker;
    });
  }

  initZoom = () => {
    window.google.maps.event.addListenerOnce(this.map, 'zoom_changed', () => {
      this.state.zoom = this.map.getZoom();
    });
  }

  zoom = (zoom) => {
    this.state.zoom = zoom;

    this.map.setZoom(zoom);
  }

  init = () => {
    this.initLocations();
    this.initMap();
    this.initMarkers();
  }
}

export default Map;
